import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';

import { tPrescriptionService } from 'src/app/services/tPrescription.service';
import { TranslateService } from '@ngx-translate/core';

import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/shared/AppSettings';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { DatePipe } from '@angular/common';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tEmployeeModel } from 'src/app/models/tEmployeeModel';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { ChineseDefaultModel, EnglishDefaultModel, SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tPrescriptionHeadModel,tPrescriptionCopyHeadModel, tPrescriptionHeadModelWithPatientBPInfo,tPrescriptionDirectionsModel } from 'src/app/models/tPrescriptionHeadModel';
import { tConsultHeadModelWithPatientInfo, tConsultHeadModel, BillPayStatus } from 'src/app/models/tConsultHeadModel';
import { tPrescriptionLineModel_withStock,tPrescriptionCopyLineModel, tPrescriptionLineModel, tPrescriptionLineModel_withStock_withRemark} from 'src/app/models/tPrescriptionLineModel';
@Component({
  selector: 'app-search-pres-copy',
  templateUrl: './search-pres-copy.component.html',
  styleUrls: ['./search-pres-copy.component.css']
})
export class SearchPresCopyComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  //@Input() dataSubmit2: tPrescriptionCopyLineModel[];
 // saveData:tRecurrJnlModel[]=new Array();
 prescriptionItemType_selection = ChineseDefaultModel.PresMediCateCodeList;
 selectedRowIndex: number = -1;
 showPortal = false;
 printHeader: tPrescriptionCopyHeadModel;
 printLine: tPrescriptionLineModel_withStock_withRemark[];
 printLine1: tPrescriptionLineModel_withStock_withRemark[] = new Array;
 printLine2: tPrescriptionLineModel_withStock_withRemark[] = new Array;
 ClickToggle=false;
 ecTypeSelectList: tEmployeeModel[];
 togglePresConfirmModel: tPrescriptionCopyHeadModel;
 isHidden_Sub1 = true;
 isHidden_Sub2 = true;
 isHidden_Sub3 = true;
 displayedColumns: string[] = [

  // 'action_button_title',

  'lineNumber',
  // 'clthConsultNumber',

  // 'action_button_newPrescription',
    'prescriptionCopyDate',
    'remark2',
    'prescriptionCopyNumber',
    'prescriptionName',
 //   'prescriptionType',
 // 'diagonsis',
  'actionSelected'


  // 'patientChiName',
  // 'patientSurname',
  // 'patientFirstName',
  // 'bpInvoiceNumber',
  ];
  dataSource: MatTableDataSource<tPrescriptionCopyHeadModel>;
  dataList: tPrescriptionCopyHeadModel[];

  diagonsisFilter = new FormControl();


  filteredValues = {
    diagonsis: ''
  };


  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
 //   private formBuilder: FormBuilder,
    public translate: TranslateService,
   // private recurrJnlService:tRecurrJnlService,
    private apiResultDialogService: ApiResultDialogService,
    public datePipe: DatePipe,
    public tPrescriptionService:tPrescriptionService,
    private tEmployeeService: tEmployeeService,
  ) { }
  ngOnInit() {
    this.getAllpres();
    this.getEC_AllowSelectList();
  }
  getAllpres(){
    this.tPrescriptionService.getAllHeadbyCopy(NavigationComponent.selectedShopID.toString(),"search").subscribe(
      data=>{
        this.dataList = data;
        this.dataSource = new MatTableDataSource<tPrescriptionCopyHeadModel>(this.dataList);
        this.dataSource.paginator = this.paginator;
        this.diagonsisFilter.valueChanges.subscribe((value) => {
          this.filteredValues['diagonsis'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });
  
        this.dataSource.filterPredicate = this.customFilterPredicate();
      }

    );
  }
  customFilterPredicate() {
    const myFilterPredicate = (data: tPrescriptionCopyHeadModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return (
       searchString.diagonsis.toLowerCase() === '' ||
        // tslint:disable-next-line:max-line-length
        (data.prescriptionName != null && data.prescriptionName.toString().trim().toLowerCase().indexOf(searchString.diagonsis.toLowerCase()) !== -1))
        ;
    }
    return myFilterPredicate;
  }

  getTypeDisplay(value){
    return this.prescriptionItemType_selection.find(p=>p.value==value).displayName
  }
  displayDateTime(currDate: Date) {

    if (!isNullOrUndefined(currDate)) {
      return this.datePipe.transform(currDate, 'yyyy/MM/dd');
      // return this.datepipe.transform(currDate, 'yyyy/MM/dd');
    }
    else
    {
      return '';
    }

  }

  selectRow(selectedModel: tPrescriptionHeadModelWithPatientBPInfo, index: number) {

    console.log("ClickSelectRow");
    if(this.ClickToggle!=true){
    this.selectedRowIndex = index;
    this.activeModal.close(selectedModel);
  }
  this.ClickToggle=false;
  }
  togglePresConfirm(){
    this.activeModal.close(this.togglePresConfirmModel);
  }

  togglePresView(selectedModel: tPrescriptionCopyHeadModel) {
    var presNum=selectedModel.prescriptionCopyNumber;
    this.togglePresConfirmModel=selectedModel;
    this.printLine=new Array;
    this.printLine1 = new Array;
    this.printLine2= new Array;
    console.log("Clicktoggle");
    this.ClickToggle=true;
    if (this.showPortal) {
      this.showPortal = false;
    } else if (!this.showPortal) {

    //  if (!isNullOrUndefined(this.printHeader)) {
    //    this.showPortal = true;
    //  } else {
        this.getPrintHead(presNum);
     // }

    }

  }

  getPrintHead(presNum: string) {

    this.printHeader = new tPrescriptionCopyHeadModel();

    this.tPrescriptionService.getCopyHead(NavigationComponent.selectedShopID.toString(),
      presNum).subscribe(result => {
        this.printHeader = result[0];
        this.switchUI(this.printHeader.prescriptionItemType);
        this.log.d('getPrintHead', JSON.stringify(this.printHeader));

        this.getPrintLine(presNum);

        this.showPortal = true;
      });
  }


  getPrintLine(presNum: string) {


    this.printLine = new Array;
    this.printLine1 = new Array;
    this.printLine2 = new Array;




    this.tPrescriptionService.getPrintCopyLine(NavigationComponent.selectedShopID.toString(),
      presNum).subscribe(data => {

        this.printLine = data;

        if (this.printLine.length > 15) {

          for (let i = 0; i < 15; i++) {

            if (this.printLine[i].mediName === null) {
              continue;
            }

            this.printLine1.push(this.printLine[i]);

            // this.lineSource1 = new MatTableDataSource<tPrescriptionLineModel_withStock>(this.line1);
          }

          for (let i = 15; i < this.printLine.length; i++) {
            this.printLine2.push(this.printLine[i]);

            // this.lineSource2 = new MatTableDataSource<tPrescriptionLineModel_withStock>(this.line2);
          }

        } else {
          this.printLine1 = this.printLine;

          const remainLines = 15 - this.printLine1.length;

          if (remainLines > 0) {

            for (let i = 0; i < remainLines; i++) {

              // const lineEmpty = new tPrescriptionLineModel_withStock_withRemark;
              // lineEmpty.mediName = '&nbsp;';

              // this.lineEmpty.push(lineEmpty);
            }


          }

          // this.lineSource1 = new MatTableDataSource<tPrescriptionLineModel_withStock>(this.line1);
        }

      });

  }
  switchUI(inputValue) {


    const value = inputValue;

    if (value === 1 || value==3) {
      this.isHidden_Sub1 = false;
      this.isHidden_Sub2 = true;
      this.isHidden_Sub3 = true;


    } else if (value === 4) {
      this.isHidden_Sub1 = true;
      this.isHidden_Sub2 = false;
      this.isHidden_Sub3 = true;
    } else if (value === 2) {
      this.isHidden_Sub1 = true;
      this.isHidden_Sub2 = true;
      this.isHidden_Sub3 = false;

    }
  }

  getEC_AllowSelectList() {
    // ecAllowSelectList
    this.tEmployeeService.getEmployeeTypeList(NavigationComponent.selectedShopID, 5).subscribe(data => {
      // this.timeSlotList = data;
      // this.log.i(this.TAG, 'getEmployeeTypeList  = ' + JSON.stringify(data));
  
      this.ecTypeSelectList = [];
      var AllEmployee=new tEmployeeModel();
      AllEmployee.employeeChiName="All";
      AllEmployee.drCMP="All";
      AllEmployee.employeeID="0";
      this.ecTypeSelectList.push(AllEmployee);
      //filter
      for (var i = 0; i < data.empolyeeList.length; i++) {
            this.ecTypeSelectList.push(data.empolyeeList[i]);
      }
  
      // this.ecTypeSelectList = data.empolyeeList;
    }, error => {
   
    });
  
  }
  displayEmlpoyeeName(value){
    if(this.ecTypeSelectList.length>0){


      return this.ecTypeSelectList.find(p=>p.employeeID==value).drCMP;

    }
  }
}
